import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappAudioRoutingModule } from './whatsapp-audio-routing.module';
import { WhatsappAudioComponent } from './whatsapp-audio.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    WhatsappAudioComponent
  ],
  imports: [
    CommonModule,
    WhatsappAudioRoutingModule,
    SharedModule,
    CommonFileUploadModule
  ],
  exports:[
    WhatsappAudioComponent
  ]
})
export class WhatsappAudioModule { }
